import { render, staticRenderFns } from "./LaboratorioCriar.vue?vue&type=template&id=669bd702"
import script from "./LaboratorioCriar.vue?vue&type=script&lang=js"
export * from "./LaboratorioCriar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports